export const subscriptionRoutes = [
  {
    name: 'subscription',
    path: '/subscription',
    component: () => import('@/modules/subscription/views/Subscription.vue'),
    meta: {
      locationTypes: ['location', 'singleLocation']
    }
  }
]
